import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/home-default.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/home-ja.tsx");
